/* =========================================================================
   DN CUSTOM v37 — ACTIVE OFFER CODE -> CHECKOUT BRIDGE
   -------------------------------------------------------------------------
   Keeps the exact offer/coupon the shopper most recently chose and forces
   that SAME code through Shopify's /discount/CODE?redirect=/checkout route.

   This listener is attached on WINDOW in capture phase, so it runs before
   the drawer's older/document-level click handlers without changing any of
   their existing behavior.
   ========================================================================= */
(function installDNCheckoutOfferBridgeV37(window, document) {
  'use strict';

  if (window.__DN_CHECKOUT_OFFER_BRIDGE_V37__) return;
  window.__DN_CHECKOUT_OFFER_BRIDGE_V37__ = true;

  var HOST = '#cart-info';
  var ACTIVE_KEY = 'dn_active_checkout_discount_code_v37';
  var CODE_KEY = 'vinova_cart_discount_code';
  var COMBO_KEY = 'comboDiscountCode';
  var navigating = false;

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }

  function normalize(code) {
    return String(code || '').trim().toUpperCase();
  }

  function closest(el, selector) {
    if (!el) return null;
    if (el.nodeType !== 1) el = el.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function cartRoot() {
    return document.querySelector(HOST);
  }

  function writeActive(code) {
    code = normalize(code);
    if (!code) return '';
    try { window.sessionStorage.setItem(ACTIVE_KEY, code); } catch (err) {}
    try {
      window.localStorage.setItem(CODE_KEY, code);
      window.localStorage.setItem(COMBO_KEY, code);
    } catch (err) {}
    syncHidden(code);
    return code;
  }

  function activeCode() {
    try {
      var code = normalize(window.sessionStorage.getItem(ACTIVE_KEY));
      if (code) return code;
    } catch (err) {}
    return '';
  }

  function inputCode() {
    var root = cartRoot() || document;
    var input = root.querySelector('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input');
    return normalize(input && input.value);
  }

  function liquidCode() {
    var cfg = document.querySelector('[data-cartui-auto-reward-config]');
    return normalize(cfg && cfg.getAttribute('data-coupon-code'));
  }

  function storedCode() {
    try {
      return normalize(window.localStorage.getItem(CODE_KEY) || window.localStorage.getItem(COMBO_KEY) || '');
    } catch (err) { return ''; }
  }

  function resolveCode() {
    /* Most recently explicitly selected offer wins. This avoids an older
       Liquid-applied coupon overriding a newer Offers & Rewards selection. */
    return activeCode() || inputCode() || liquidCode() || storedCode();
  }

  function syncHidden(code) {
    code = normalize(code);
    if (!code) return;
    var root = cartRoot();
    if (!root) return;
    var form = root.querySelector('form.cart, form[action="/cart"], form[action$="/cart"]');
    if (!form) return;
    var hidden = form.querySelector('input[data-dn-checkout-discount]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'discount';
      hidden.setAttribute('data-dn-checkout-discount', '');
      form.appendChild(hidden);
    }
    if (hidden.value !== code) hidden.value = code;
  }

  function rememberFromApplyTarget(target) {
    var row = closest(target, '[data-dn-apply-code]');
    if (row) return writeActive(row.getAttribute('data-dn-apply-code'));

    var fieldBtn = closest(target, '[data-dn-apply-field], [data-cu-apply-discount], .cu-coupon-apply, #save-discount-btn');
    if (fieldBtn) {
      var box = closest(fieldBtn, '.cu-coupon') || cartRoot() || document;
      var input = box.querySelector('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input');
      return writeActive(input && input.value);
    }
    return '';
  }

  function isCheckoutTarget(target) {
    return closest(target,
      '[data-dn-checkout-with-coupon], .cu-checkout[name="checkout"], .cart__checkout[name="checkout"], button[name="checkout"], input[name="checkout"]'
    );
  }

  function stop(e) {
    if (!e) return;
    if (e.cancelable !== false) e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    else e.stopPropagation();
  }

  function setBusy(button) {
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var label = button.querySelector && button.querySelector('span:first-child');
    if (label) {
      if (!button.getAttribute('data-dn-original-checkout-label')) {
        button.setAttribute('data-dn-original-checkout-label', label.textContent || 'Checkout');
      }
      label.textContent = 'LOADING…';
    }
  }

  function showCheckoutError(button, err) {
    navigating = false;
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      var label = button.querySelector && button.querySelector('span:first-child');
      var original = button.getAttribute('data-dn-original-checkout-label');
      if (label && original) label.textContent = original;
    }
    if (window.console) console.error('[DN Cart] Checkout gift verification failed:', err);
    window.alert('We could not finish updating your free gifts. Please try checkout again. Your cart has been kept open.');
  }

  function goCheckout(code, button) {
    if (navigating) return true;
    navigating = true;
    setBusy(button);

    var engine = window.DNCartUI;
    // Let the controller finish, and always verify the final actual Shopify cart.
    // On temporarily missing drawer config, safely allow a cart with NO tagged
    // gifts to use the native checkout; never allow an unverified gift cart.
    function safeToProceedWithoutConfig() {
      return window.fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
        .then(function (cart) {
          var hasGift = (cart.items || []).some(function (item) {
            var props = item.properties || {};
            return String(props._cartui_auto_reward) === 'true' || String(props._cartui_reward_v36) === 'true';
          });
          if (hasGift) throw new Error('Cannot verify free gifts without cart configuration');
          return true;
        });
    }
    function verify() {
      if (!engine || typeof engine.sync !== 'function' || typeof engine.verifyRewards !== 'function') {
        return safeToProceedWithoutConfig();
      }
      // Fast path: normal checkout should not mutate the cart on every click.
      // A valid, settled cart goes straight to Shopify without any reward writes.
      // If a scheduled/background sync is already running, join it first.
      function settleIfNeeded() {
        return Promise.resolve(engine.verifyRewards()).then(function (valid) {
          if (valid) return true;
          // Only inconsistent carts need add/remove requests.
          return Promise.resolve(engine.sync()).then(function (result) {
            if (!result || !result.stable) throw new Error('Gift reconciliation incomplete');
            return engine.verifyRewards();
          }).then(function (rechecked) {
            if (!rechecked) throw new Error('Gift cart state invalid after repair');
            return true;
          });
        });
      }
      var pending = typeof engine.currentSync === 'function' ? engine.currentSync() : null;
      return Promise.resolve(pending).then(settleIfNeeded).catch(function (err) {
        if (err && /Missing reward configuration|Reward controller is not ready/.test(String(err.message || err))) {
          return safeToProceedWithoutConfig();
        }
        throw err;
      });
    }
    // Do not trap shoppers behind a fixed 12-second timer. Checkout proceeds
    // immediately after actual reward reconciliation + final cart verification.
    // A failed validation keeps the cart open and restores the button.
    verify().then(function () {
      code = normalize(code);
      window.location.assign(code
        ? route('discount/' + encodeURIComponent(code) + '?redirect=/checkout')
        : route('checkout'));
    }).catch(function (err) {
      showCheckoutError(button, err);
    });
    return true;
  }

  /* WINDOW capture runs before the drawer's DOCUMENT capture handlers. */
  window.addEventListener('click', function (e) {
    if (!closest(e.target, HOST)) return;

    rememberFromApplyTarget(e.target);

    var checkout = isCheckoutTarget(e.target);
    if (!checkout) return;
    var code = resolveCode();
    stop(e);
    goCheckout(code, checkout);
  }, true);

  /* Enter on the coupon field is also an explicit selection. */
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !closest(e.target, HOST)) return;
    var input = closest(e.target, '[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input');
    if (input) writeActive(input.value);
  }, true);

  /* Covers keyboard/native requestSubmit paths that do not originate from a
     checkout button click. */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !closest(form, HOST)) return;
    var code = resolveCode();
    if (navigating) { stop(e); return; }
    stop(e);
    goCheckout(code, e.submitter || form.querySelector('[name="checkout"]'));
  }, true);

  /* Keep the hidden native fallback synchronized after AJAX drawer redraws. */
  if (window.MutationObserver) {
    var obs = new window.MutationObserver(function () {
      var code = resolveCode();
      if (code) syncHidden(code);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.DNCheckoutOfferBridgeV37 = {
    getCode: resolveCode,
    remember: writeActive,
    checkout: function (code) { return goCheckout(code || resolveCode(), null); }
  };
})(window, document);

(function (window, document) {
  'use strict';

  if (window.__DN_CART_UI_V37__) {
    if (window.DNCartUI && window.DNCartUI.init) window.DNCartUI.init();
    return;
  }
  window.__DN_CART_UI_V37__ = true;

  /* Make every historical reward/cart controller stand down if it loads later.
     v36 itself does NOT depend on these old guards. */
  window.__DN_CART_UI_V25__ = true;
  window.__DN_CART_UI_V32_ACTIVE__ = false;
  window.__VINOVA_TIER_REWARDS_V22__ = true;
  window.__DN_TIER4_ENFORCER_V33__ = true;
  window.__DN_TIER4_ENFORCER_V34__ = true;
  window.__DN_TIER4_FALLBACK_V32__ = true;
  window.__DN_FULL_DISCOUNT_REWARD_GUARD_V30__ = true;
  window.__DN_CHECKOUT_COUPON_GUARD_V31__ = true;
  window.__DN_CART_OFFERS_V10__ = true;

  /* Shared, first-come-first-served flag with the inline bootstrap in
     cart-ajax.liquid. Exactly one of the two binds the View Details /
     View All Offers toggles, so they can never double-fire and can never
     both be missing. */
  var OWNS_TOGGLES = !window.__DN_CART_TOGGLES__;
  if (OWNS_TOGGLES) window.__DN_CART_TOGGLES__ = 'asset';

  var $ = window.jQuery;

  var CART_HOST       = '#cart-info';
  var CONFIG_SELECTOR = '[data-cartui-auto-reward-config]';
  var STATE_KEY       = 'dn_cartui_tier_state_v36';
  var CLOCK_KEY       = 'dn_cartui_deadline_v26';
  var CODE_KEY        = 'vinova_cart_discount_code';
  var COMBO_KEY       = 'comboDiscountCode';
  var ANIM            = 260;

  var scheduleTimer = null;
  var syncing = false;
  var queued = false;
  var activeSyncPromise = null;
  var observer = null;
  var celebrationTimer = null;
  var mainClock = null;
  var failedTiers = {};

  /* =======================================================================
     A. HELPERS
     ======================================================================= */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function closest(el, sel) {
    if (!el) return null;
    if (el.nodeType !== 1) el = el.parentElement;
    return el && el.closest ? el.closest(sel) : null;
  }
  function cartRoot(from) { return (from && closest(from, CART_HOST)) || qs(CART_HOST); }
  function inCart(t) { return !!(t && closest(t, CART_HOST)); }
  function stop(e) {
    if (!e) return;
    if (e.cancelable !== false) e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }
  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path || '').replace(/^\//, '');
  }
  function toBool(v) { return String(v).toLowerCase() === 'true'; }
  function toInt(v, f) { var n = parseInt(v, 10); return isNaN(n) ? (f || 0) : n; }
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '\u20B9{{amount}}');
    }
    return '\u20B9' + (toInt(cents, 0) / 100).toFixed(2);
  }
  function requestJSON(path, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';
    if (options.body && !options.headers['Content-Type']) options.headers['Content-Type'] = 'application/json';
    return window.fetch(route(path), options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Cart request failed.');
        return data;
      });
    });
  }
  function getCart() { return requestJSON('cart.js', { method: 'GET' }); }

  function updateHeaderCart(cart) {
    if (!cart) return;
    qsa('#CartCount, #CartCountCavas').forEach(function (el) { el.textContent = cart.item_count; });
    var total = qs('#cart_total');
    if (total && window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
      total.innerHTML = window.Shopify.formatMoney(cart.total_price, window.theme.moneyFormat);
    }
  }
  function refreshDrawer(cart) {
    updateHeaderCart(cart);
    var host = qs(CART_HOST);
    if (!host) return Promise.resolve();
    if ($ && $.get) {
      return new Promise(function (resolve) {
        $.get(route('cart?view=json'), function (html) { $(host).html(html); }).always(resolve);
      });
    }
    return window.fetch(route('cart?view=json'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { host.innerHTML = html; });
  }

  /* =======================================================================
     B. COUNTDOWN — a real timer, persisted so it survives drawer re-renders
     ======================================================================= */
  function paintClock(minEl, secEl, total) {
    if (total < 0) total = 0;
    var mm = Math.floor(total / 60), ss = total % 60;
    if (minEl) minEl.textContent = mm + 'm';
    if (secEl) secEl.textContent = (ss < 10 ? '0' + ss : '' + ss) + 's';
  }
  function getDeadline(minutes) {
    var now = Date.now();
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(CLOCK_KEY) || 'null');
      if (stored && toInt(stored.minutes, 0) === minutes && toInt(stored.deadline, 0) > now) {
        return toInt(stored.deadline, 0);
      }
    } catch (err) {}
    var next = now + (minutes * 60 * 1000);
    try {
      window.sessionStorage.setItem(CLOCK_KEY, JSON.stringify({ minutes: minutes, deadline: next }));
    } catch (err) {}
    return next;
  }
  function startClock() {
    if (mainClock) { window.clearInterval(mainClock); mainClock = null; }
    var root = qs(CART_HOST);
    if (!root) return;
    var box = qs('[data-cartui-countdown]', root);
    if (!box) return;

    var minutes = toInt(box.getAttribute('data-minutes'), 10) || 10;
    var deadline = getDeadline(minutes);

    function tick() {
      var host = qs(CART_HOST);
      if (!host) { window.clearInterval(mainClock); mainClock = null; return; }
      var left = Math.round((deadline - Date.now()) / 1000);
      if (left <= 0) {
        left = minutes * 60;
        deadline = Date.now() + (left * 1000);
        try { window.sessionStorage.setItem(CLOCK_KEY, JSON.stringify({ minutes: minutes, deadline: deadline })); } catch (err) {}
      }
      paintClock(qs('[data-cartui-min]', host), qs('[data-cartui-sec]', host), left);
      /* mirror into the offers panel */
      paintClock(qs('[data-cu-min]', host), qs('[data-cu-sec]', host), left);
    }
    tick();
    mainClock = window.setInterval(tick, 1000);
  }

  /* =======================================================================
     C. PRICE DETAILS ACCORDION
     ======================================================================= */
  function getDetails(root) { return qs('[data-cartui-details-panel], .cu-details-inline', root || document); }
  function getDrawer(root) {
    return (root && root.classList && root.classList.contains('cu-drawer')) ? root :
           (root && qs('.cu-drawer', root)) || closest(root, '.cu-drawer') || qs('.cu-drawer') || root;
  }
  function outerH(el) {
    if (!el) return 0;
    var h = el.offsetHeight || 0;
    try {
      var cs = window.getComputedStyle(el);
      h += (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
    } catch (err) {}
    return h;
  }
  function fitDetailsPanel(root, panel) {
    root = cartRoot(root) || root || qs(CART_HOST);
    panel = panel || getDetails(root);
    if (!root || !panel) return;

    var drawer = getDrawer(root);
    var bottom = closest(panel, '.cu-bottom') || qs('.cu-bottom', root);
    var top = qs('.cu-top', root);
    var viewRow = bottom ? qs('.cu-view-row', bottom) : null;
    var savedBar = bottom ? qs('.cu-saved-banner', bottom) : null;
    var checkout = bottom ? qs('.cu-checkout', bottom) : null;

    var drawerH = (drawer && drawer.clientHeight) || window.innerHeight || document.documentElement.clientHeight || 0;
    var topH = top ? top.offsetHeight : 0;
    var padT = 22, padB = 54;
    if (bottom && window.getComputedStyle) {
      var bcs = window.getComputedStyle(bottom);
      padT = parseFloat(bcs.paddingTop) || padT;
      padB = parseFloat(bcs.paddingBottom) || padB;
    }
    var fixedH = padT + padB + outerH(viewRow) + outerH(savedBar) + outerH(checkout) + 24;
    var available = Math.max(180, drawerH - topH - 8);
    var maxPanel = Math.floor(available - fixedH);
    /* checkout visibility wins; the panel scrolls inside this height */
    maxPanel = Math.max(92, Math.min(maxPanel, 285));
    panel.style.setProperty('--cu-details-max', maxPanel + 'px');
  }
  function setDetailsState(root, open) {
    root = cartRoot(root) || root || qs(CART_HOST);
    if (!root) return false;
    var panel = getDetails(root);
    if (!panel) return false;

    if (open) {
      fitDetailsPanel(root, panel);
      panel.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        fitDetailsPanel(root, panel);
        panel.classList.add('is-open');
      });
    } else {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.removeProperty('--cu-details-max');
    }
    qsa('[data-cartui-details]', root).forEach(function (t) {
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    return false;
  }
  function toggleDetails(btn) {
    var root = cartRoot(btn);
    if (!root) return false;
    var panel = getDetails(root);
    if (!panel) return false;
    return setDetailsState(root, !panel.classList.contains('is-open'));
  }

  /* =======================================================================
     D. OFFERS PANEL
     ======================================================================= */
  function getPanel(root) {
    return qs('[data-cu-offers-panel], [data-cartui-panel="offers"], .cu-offers-panel', root || document);
  }
  function openOffers(from) {
    var root = cartRoot(from);
    if (!root) return false;
    var panel = getPanel(root);
    if (!panel) { if (window.console) console.warn('[DN Cart v36] offers panel not found.'); return false; }
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      syncInputs(panel);
    });
    return false;
  }
  function closeOffers(from) {
    var root = cartRoot(from);
    if (!root) return false;
    var panel = getPanel(root);
    if (!panel) return false;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () { panel.setAttribute('hidden', 'hidden'); }, ANIM);
    return false;
  }
  function toggleMore(btn) {
    var item = closest(btn, '.cu-payoffer');
    var details = item ? qs('.cu-pay-details, [data-cu-pay-details]', item) : null;
    if (!details) return false;
    var open = details.hasAttribute('hidden') || !details.classList.contains('is-open');
    if (open) { details.removeAttribute('hidden'); details.classList.add('is-open'); }
    else { details.setAttribute('hidden', 'hidden'); details.classList.remove('is-open'); }
    btn.textContent = open ? 'Show Less' : 'Show More';
    return false;
  }

  /* =======================================================================
     E. COUPON ENGINE
     ----------------------------------------------------------------------
     /discount/CODE?redirect=/cart.js puts the code on the cart session server
     side, so cart.cart_level_discount_applications is populated and the Liquid
     Price Details block can print a real coupon value on the next render.
     ======================================================================= */
  function setMessage(text, type) {
    qsa('[data-dn-offer-msg]').forEach(function (box) {
      box.hidden = !text;
      box.textContent = text || '';
      box.classList.remove('is-success', 'is-error', 'is-info');
      if (text) box.classList.add(type || 'is-info');
    });
    qsa('[data-cu-discount-message], [data-cartui-discount-message]').forEach(function (el) {
      el.hidden = !text;
      el.textContent = text || '';
      el.classList.remove('is-success', 'is-error');
      if (text) el.classList.add(type === 'is-error' ? 'is-error' : 'is-success');
    });
  }
  function getCode() {
    if (window.DNCheckoutOfferBridgeV37 && typeof window.DNCheckoutOfferBridgeV37.getCode === 'function') {
      var active = window.DNCheckoutOfferBridgeV37.getCode();
      if (active) return active;
    }
    var cfg = qs(CONFIG_SELECTOR);
    var liquid = cfg ? String(cfg.getAttribute('data-coupon-code') || '').trim() : '';
    if (liquid) return liquid;
    try {
      return (window.localStorage.getItem(CODE_KEY) || window.localStorage.getItem(COMBO_KEY) || '').trim();
    } catch (err) { return ''; }
  }
  function rememberCode(code) {
    if (window.DNCheckoutOfferBridgeV37 && typeof window.DNCheckoutOfferBridgeV37.remember === 'function') {
      window.DNCheckoutOfferBridgeV37.remember(code);
      return;
    }
    try {
      window.localStorage.setItem(CODE_KEY, code);
      window.localStorage.setItem(COMBO_KEY, code);
    } catch (err) {}
  }
  function syncInputs(root, code) {
    root = root || qs(CART_HOST) || document;
    code = code || getCode();
    if (!code) return;
    qsa('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]', root)
      .forEach(function (input) {
        if (input && input.tagName === 'INPUT' && !input.value) input.value = code;
      });
  }
  function codeIsApplied(cart, code) {
    var wanted = String(code || '').toUpperCase();
    var apps = [].concat(
      (cart && cart.discount_applications) || [],
      (cart && cart.cart_level_discount_applications) || []
    );
    return apps.some(function (a) {
      return String(a.title || a.code || '').toUpperCase() === wanted;
    });
  }
  function applyDiscountCode(code, btn) {
    code = String(code || '').trim().toUpperCase();
    if (!code) {
      setMessage('Please enter a coupon code.', 'is-error');
      return Promise.resolve(false);
    }

    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'APPLYING'; }
    setMessage('Applying ' + code + '\u2026', 'is-info');

    return window.fetch(route('discount/' + encodeURIComponent(code) + '?redirect=/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json().catch(function () { return null; }); })
      .then(function (cart) { return (cart && cart.items) ? cart : getCart(); })
      .then(function (cart) {
        rememberCode(code);
        var applied = codeIsApplied(cart, code);

        if (applied) {
          setMessage('Coupon ' + code + ' applied.', 'is-success');
          if (btn) { btn.classList.add('is-applied'); btn.textContent = 'APPLIED'; }
        } else {
          /* code accepted but order-level / line-level only, or not valid here */
          setMessage('Coupon ' + code + ' saved. If it is valid it will apply at checkout.', 'is-info');
          if (btn) btn.textContent = label || 'APPLY';
        }

        qsa('[data-dn-coupon-input], [data-cu-discount-input]').forEach(function (i) {
          if (i && i.tagName === 'INPUT') i.value = code;
        });

        /* Refresh the discounted cart first, then reconcile rewards immediately.
           If this coupon fully covers paid merchandise, syncRewards() removes
           the reward from the REAL Shopify cart before the customer continues. */
        return refreshDrawer(cart)
          .then(function () { return syncRewards(); })
          .then(function () { return applied; });
      })
      .catch(function (err) {
        if (window.console) console.warn('[DN Cart v36] coupon apply:', err);
        setMessage('Could not apply ' + code + '. Please check the code and try again.', 'is-error');
        return false;
      })
      .then(function (result) {
        if (btn) { btn.disabled = false; if (!btn.classList.contains('is-applied')) btn.textContent = label || 'APPLY'; }
        return result;
      });
  }
  function checkoutWithDiscount(e, btn) {
    var code = getCode();
    if (!code) {
      var input = qs('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input', cartRoot(btn) || document);
      code = input && input.value ? input.value.trim() : '';
    }
    if (!code) return false;
    stop(e);
    rememberCode(code);
    if (window.DNCheckoutOfferBridgeV37 && typeof window.DNCheckoutOfferBridgeV37.checkout === 'function') {
      return window.DNCheckoutOfferBridgeV37.checkout(code);
    }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    Promise.resolve(syncRewards()).then(function (result) {
      if (!result || !result.stable) throw new Error('Reward sync incomplete');
      return verifyRewards();
    }).then(function (valid) {
      if (!valid) throw new Error('Reward verification failed');
      window.location.href = route('discount/' + encodeURIComponent(code) + '?redirect=/checkout');
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      window.alert('Free gifts could not be verified. Please try checkout again.');
      if (window.console) console.error(err);
    });
    return true;
  }

  /* =======================================================================
     F. REWARD ENGINE — DN CUSTOM v36
     -----------------------------------------------------------------------
     ONE reward controller owns Tier 2 / Tier 3 / Tier 4.

       Tier 1 -> shipping only
       Tier 2 -> Tier 2 product only
       Tier 3 -> Tier 3 product only
       Tier 4 -> Tier 2 + Tier 3 products together
       100% coupon -> no reward products

     v36 uses its own private cart-line marker (_cartui_reward_v36). Older
     reward scripts only know _cartui_auto_reward, so they cannot remove or
     re-add v36 gift lines. Historical reward lines are cleaned up after the
     v36 replacements are safely present.
     ======================================================================= */
  var TIER_NUMBERS = [2, 3, 4];
  var REWARD_MARKER = '_cartui_reward_v36';
  var LEGACY_MARKER = '_cartui_auto_reward';

  function uniquePositiveInts(values) {
    var seen = {};
    return (values || []).map(function (v) { return toInt(v, 0); }).filter(function (v) {
      if (v <= 0 || seen[v]) return false;
      seen[v] = true;
      return true;
    });
  }

  function parseVariantIds(value) {
    return uniquePositiveInts(String(value || '').split(/[|,]/));
  }

  function isV36Reward(item) {
    return !!(item && item.properties && String(item.properties[REWARD_MARKER]) === 'true');
  }

  function isLegacyReward(item) {
    return !!(item && item.properties && String(item.properties[LEGACY_MARKER]) === 'true');
  }

  function isAnyReward(item) {
    return isV36Reward(item) || isLegacyReward(item);
  }

  function getConfig() {
    var el = qs(CONFIG_SELECTOR);
    if (!el) {
      if (!window.__DN_CART_CONFIG_WARNED__ && window.console) {
        window.__DN_CART_CONFIG_WARNED__ = true;
        console.warn('[DN Cart v36] Missing reward config node.');
      }
      return null;
    }

    var t2Id = toInt(el.getAttribute('data-tier2-variant-id'), 0);
    var t3Id = toInt(el.getAttribute('data-tier3-variant-id'), 0);
    var t4Ids = parseVariantIds(el.getAttribute('data-tier4-variant-ids'));
    if (t4Ids.length < 2) t4Ids = uniquePositiveInts([t2Id, t3Id]);

    function baseEnabled(n) {
      var base = el.getAttribute('data-tier' + n + '-base-enabled');
      if (base !== null) return toBool(base);
      return toBool(el.getAttribute('data-tier' + n + '-enabled'));
    }

    return {
      enabled:              toBool(el.getAttribute('data-enabled')),
      fullDiscount:         toBool(el.getAttribute('data-full-discount')),
      realMerchSubtotal:    toInt(el.getAttribute('data-real-merchandise-subtotal'), 0),
      liquidCouponDiscount: toInt(el.getAttribute('data-coupon-discount'), 0),
      rewardsVisible:       toBool(el.getAttribute('data-rewards-visible')),
      celebrationEnabled:   toBool(el.getAttribute('data-celebration-enabled')),
      celebrationSeconds:   Math.max(2, Math.min(10, toInt(el.getAttribute('data-celebration-seconds'), 5))),
      celebrationButton:    el.getAttribute('data-celebration-button') || 'Continue Shopping',
      tiers: {
        2: {
          enabled: baseEnabled(2),
          threshold: toInt(el.getAttribute('data-tier2-threshold'), 0),
          variantIds: uniquePositiveInts([t2Id]),
          showMarker: true,
          productTitle: el.getAttribute('data-tier2-product-title') || '',
          worth: toInt(el.getAttribute('data-tier2-worth'), 0),
          popupTitle: el.getAttribute('data-tier2-popup-title') || 'Tier 2 unlocked!',
          popupText: el.getAttribute('data-tier2-popup-text') || 'Your reward has been added to the cart.'
        },
        3: {
          enabled: baseEnabled(3),
          threshold: toInt(el.getAttribute('data-tier3-threshold'), 0),
          variantIds: uniquePositiveInts([t3Id]),
          showMarker: true,
          productTitle: el.getAttribute('data-tier3-product-title') || '',
          worth: toInt(el.getAttribute('data-tier3-worth'), 0),
          popupTitle: el.getAttribute('data-tier3-popup-title') || 'Tier 3 unlocked!',
          popupText: el.getAttribute('data-tier3-popup-text') || 'Your reward has been added to the cart.'
        },
        4: {
          enabled: (function () {
            var base = el.getAttribute('data-tier4-base-enabled');
            return base !== null ? toBool(base) : toBool(el.getAttribute('data-tier4-enabled'));
          })(),
          threshold: toInt(el.getAttribute('data-tier4-threshold'), 0),
          variantIds: t4Ids,
          showMarker: toBool(el.getAttribute('data-tier4-show-marker')),
          productTitle: el.getAttribute('data-tier4-product-title') || '',
          worth: toInt(el.getAttribute('data-tier4-worth'), 0),
          popupTitle: el.getAttribute('data-tier4-popup-title') || 'Tier 4 unlocked!',
          popupText: el.getAttribute('data-tier4-popup-text') || 'Both reward gifts have been added to the cart.'
        }
      }
    };
  }

  function getState(cfg) {
    var signature = TIER_NUMBERS.map(function (n) {
      var t = cfg.tiers[n];
      return [n, t.enabled ? 1 : 0, t.threshold, t.variantIds.join(',')].join(':');
    }).join('|');
    var fallback = { signature: signature, activeTier: 0, celebrated: {} };
    try {
      var p = JSON.parse(window.sessionStorage.getItem(STATE_KEY) || 'null');
      if (!p || p.signature !== signature) return fallback;
      return { signature: signature, activeTier: toInt(p.activeTier, 0), celebrated: p.celebrated || {} };
    } catch (err) { return fallback; }
  }

  function setState(state, activeTier, celebrated) {
    try {
      window.sessionStorage.setItem(STATE_KEY, JSON.stringify({
        signature: state.signature,
        activeTier: activeTier,
        celebrated: celebrated || {}
      }));
    } catch (err) {}
  }

  /* Reward products never contribute to the threshold that unlocked them. */
  function qualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return isAnyReward(item) ? sum : sum + toInt(item.final_line_price, 0);
    }, 0);
  }

  function activeTierFor(cart, cfg) {
    if (!cfg || !cfg.enabled || cfg.fullDiscount) return 0;
    var subtotal = qualifyingSubtotal(cart);
    var t2 = cfg.tiers[2], t3 = cfg.tiers[3], t4 = cfg.tiers[4];

    if (t4.enabled && t4.threshold > 0 && t4.threshold > t3.threshold &&
        t4.variantIds.length >= 2 && subtotal >= t4.threshold) return 4;
    if (t3.enabled && t3.threshold > 0 && t3.variantIds.length && subtotal >= t3.threshold) return 3;
    if (t2.enabled && t2.threshold > 0 && t2.variantIds.length && subtotal >= t2.threshold) return 2;
    return 0;
  }

  function desiredIdsFor(activeTier, cfg) {
    if (!activeTier || !cfg || !cfg.tiers[activeTier]) return [];
    return cfg.tiers[activeTier].variantIds.slice();
  }

  function addRewardVariant(id, activeTier) {
    return requestJSON('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        quantity: 1,
        properties: {
          _cartui_reward_v36: 'true',
          _cartui_reward_state: String(activeTier)
        }
      })
    });
  }

  function removeRewardLine(item) {
    return requestJSON('cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  function addSequential(ids, activeTier) {
    return (ids || []).reduce(function (p, id) {
      return p.then(function () { return addRewardVariant(id, activeTier); });
    }, Promise.resolve());
  }

  function removeSequential(lines) {
    return (lines || []).reduce(function (p, item) {
      return p.then(function () { return removeRewardLine(item); });
    }, Promise.resolve());
  }

  function inspectRewardState(cart, desired, activeTier) {
    var desiredMap = {};
    desired.forEach(function (id) { desiredMap[id] = true; });

    var keep = {};
    var staleV36 = [];
    var legacy = [];

    (cart.items || []).forEach(function (item) {
      var id = toInt(item.id, 0);
      if (isLegacyReward(item)) {
        legacy.push(item);
        return;
      }
      if (!isV36Reward(item)) return;

      var correctState = String(item.properties._cartui_reward_state || '') === String(activeTier);
      if (desiredMap[id] && correctState && !keep[id] && toInt(item.quantity, 0) === 1) {
        keep[id] = item;
      } else {
        staleV36.push(item);
      }
    });

    var missing = desired.filter(function (id) { return !keep[id]; });
    return { keep: keep, missing: missing, staleV36: staleV36, legacy: legacy };
  }

  function reconcilePass(passNo) {
    var cfg = getConfig();
    if (!cfg) return Promise.reject(new Error('Missing reward configuration'));

    return getCart().then(function (cart) {
      var activeTier = activeTierFor(cart, cfg);
      var desired = desiredIdsFor(activeTier, cfg);
      var plan = inspectRewardState(cart, desired, activeTier);
      var changed = plan.missing.length > 0 || plan.staleV36.length > 0 || plan.legacy.length > 0;

      // Remove obsolete / duplicate rewards BEFORE adding replacements.
      // This prevents a temporary ₹500 + ₹800 double-gift at Tier 3.
      var cleanup = plan.staleV36.concat(plan.legacy);
      return removeSequential(cleanup)
        .then(function () { return cleanup.length ? getCart() : cart; })
        .then(function (afterRemoval) {
          // Re-evaluate against the actual cart after removal; never trust stale plans.
          var freshTier = activeTierFor(afterRemoval, getConfig() || cfg);
          var freshDesired = desiredIdsFor(freshTier, getConfig() || cfg);
          var fresh = inspectRewardState(afterRemoval, freshDesired, freshTier);
          return addSequential(fresh.missing, freshTier).then(function () {
            return { changed: changed || fresh.missing.length > 0, activeTier: freshTier, desired: freshDesired };
          });
        });
    }).then(function (result) {
      return getCart().then(function (cart) {
        var cfg2 = getConfig() || cfg;
        var activeTier2 = activeTierFor(cart, cfg2);
        var desired2 = desiredIdsFor(activeTier2, cfg2);
        var check = inspectRewardState(cart, desired2, activeTier2);
        var stable = check.missing.length === 0 && check.staleV36.length === 0 && check.legacy.length === 0;

        if (!stable && passNo < 3) {
          return new Promise(function (resolve) {
            window.setTimeout(function () { resolve(reconcilePass(passNo + 1)); }, 140);
          });
        }
        result.stable = stable;
        result.activeTier = activeTier2;
        result.desired = desired2;
        result.cart = cart;
        return result;
      });
    });
  }

  function chooseCelebration(prev, activeTier, cfg) {
    if (!activeTier || !cfg.celebrationEnabled || !cfg.rewardsVisible) return 0;
    if (activeTier === 4 && !cfg.tiers[4].showMarker) return 0;
    if (prev.activeTier === activeTier || prev.celebrated[String(activeTier)]) return 0;
    return activeTier;
  }

  function syncRewards() {
    if (syncing) { return activeSyncPromise || Promise.reject(new Error('Reward sync busy')); }
    syncing = true;
    queued = false;

    var cfg = getConfig();
    if (!cfg) { syncing = false; return Promise.reject(new Error('Missing reward configuration')); }
    var prev = getState(cfg);
    var celebrationTier = 0;

    activeSyncPromise = reconcilePass(0)
      .then(function (result) {
        if (!result || !result.stable) throw new Error('Reward reconciliation did not settle');
        celebrationTier = chooseCelebration(prev, result.activeTier, cfg);
        var celebrated = prev.celebrated || {};
        if (celebrationTier) celebrated[String(celebrationTier)] = true;
        setState(prev, result.activeTier, celebrated);

        if (result.changed || !result.stable) {
          updateHeaderCart(result.cart);
          // Do not make checkout depend on an optional HTML drawer refresh.
          // Update drawer asynchronously after verified cart operations settle.
          window.setTimeout(function () { refreshDrawer(result.cart).catch(function () {}); }, 0);
          return result;
        }
        updateHeaderCart(result.cart);
        return result;
      })
      .then(function (result) {
        if (celebrationTier) showCelebration(getConfig() || cfg, celebrationTier);
        return result;
      })
      .catch(function (err) {
        if (window.console) console.error('[DN Cart v36] reward sync:', err);
        throw err;
      })
      .then(function (result) {
        syncing = false;
        activeSyncPromise = null;
        if (queued) scheduleSync(70);
        return result;
      }, function (err) {
        syncing = false;
        activeSyncPromise = null;
        throw err;
      });
    return activeSyncPromise;
  }

  function verifyRewards() {
    var cfg = getConfig();
    if (!cfg) return Promise.reject(new Error('Missing reward configuration'));
    return getCart().then(function (cart) {
      var tier = activeTierFor(cart, cfg);
      var desired = desiredIdsFor(tier, cfg);
      var plan = inspectRewardState(cart, desired, tier);
      return plan.missing.length === 0 && plan.staleV36.length === 0 && plan.legacy.length === 0;
    });
  }

  function scheduleSync(delay) {
    if (scheduleTimer) window.clearTimeout(scheduleTimer);
    scheduleTimer = window.setTimeout(function () {
      scheduleTimer = null;
      syncRewards().catch(function (err) {
        if (window.console) console.warn('[DN Cart] background reward sync failed:', err);
      });
    }, typeof delay === 'number' ? delay : 100);
  }

  /* =======================================================================
     G. CELEBRATION POPUP
     ======================================================================= */
  function removeCelebration() {
    if (celebrationTimer) { window.clearTimeout(celebrationTimer); celebrationTimer = null; }
    var el = qs('.cu-reward-celebration');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }
  function showCelebration(cfg, tierNumber) {
    if (!cfg.celebrationEnabled) return;
    var tier = cfg.tiers[tierNumber];
    if (!tier) return;
    removeCelebration();

    var popup = document.createElement('div');
    popup.className = 'cu-reward-celebration';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'cu-reward-celebration-title');

    var backdrop = document.createElement('div');
    backdrop.className = 'cu-reward-celebration__backdrop';
    backdrop.setAttribute('data-cu-reward-close', '');

    var card = document.createElement('div');
    card.className = 'cu-reward-celebration__card';

    var confetti = document.createElement('div');
    confetti.className = 'cu-reward-confetti';
    confetti.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 12; i += 1) confetti.appendChild(document.createElement('i'));

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cu-reward-celebration__close';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-cu-reward-close', '');
    close.innerHTML = '&times;';

    var icon = document.createElement('div');
    icon.className = 'cu-reward-celebration__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '\uD83C\uDF89';

    var title = document.createElement('h3');
    title.id = 'cu-reward-celebration-title';
    title.className = 'cu-reward-celebration__title';
    title.textContent = tier.popupTitle;

    var text = document.createElement('p');
    text.className = 'cu-reward-celebration__text';
    text.textContent = tier.popupText;

    if (tier.productTitle) {
      var product = document.createElement('span');
      product.className = 'cu-reward-celebration__product';
      product.textContent = tier.productTitle;
      text.appendChild(product);
    }
    if (tier.worth > 0) {
      var worth = document.createElement('span');
      worth.className = 'cu-reward-celebration__worth';
      worth.textContent = 'Worth ' + money(tier.worth);
      text.appendChild(worth);
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cu-reward-celebration__button';
    button.setAttribute('data-cu-reward-close', '');
    button.textContent = cfg.celebrationButton;

    card.appendChild(confetti);
    card.appendChild(close);
    card.appendChild(icon);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(button);
    popup.appendChild(backdrop);
    popup.appendChild(card);
    document.body.appendChild(popup);

    window.setTimeout(function () { button.focus(); }, 50);
    celebrationTimer = window.setTimeout(removeCelebration, cfg.celebrationSeconds * 1000);
  }

  /* =======================================================================
     H. DELEGATION + WIRING
     ======================================================================= */
  function handleClick(e) {
    if (closest(e.target, '[data-cu-reward-close]')) { e.preventDefault(); removeCelebration(); return; }
    if (!inCart(e.target)) return;

    var checkout = closest(e.target, '.cu-checkout[name="checkout"], .cart__checkout[name="checkout"], button[name="checkout"]');
    if (checkout && checkoutWithDiscount(e, checkout)) return;

    if (OWNS_TOGGLES) {
      var detailsToggle = closest(e.target, '[data-cartui-details]');
      if (detailsToggle) { stop(e); toggleDetails(detailsToggle); return; }

      var openBtn = closest(e.target, '[data-cu-open-offers], [data-cartui-open="offers"], .cu-viewall');
      if (openBtn) { stop(e); openOffers(openBtn); return; }

      var closeBtn = closest(e.target, '.cu-op-close, [data-cu-close-offers], [data-cartui-panel-close], .cu-overlay-close, .cu-back');
      if (closeBtn && closest(closeBtn, '[data-cu-offers-panel], .cu-offers-panel')) { stop(e); closeOffers(closeBtn); return; }

      var moreBtn = closest(e.target, '[data-cu-more], [data-cartui-more], .cu-more');
      if (moreBtn && closest(moreBtn, '.cu-payoffer')) { stop(e); toggleMore(moreBtn); return; }
    }

    var rowBtn = closest(e.target, '[data-dn-apply-code]');
    if (rowBtn) { stop(e); applyDiscountCode(rowBtn.getAttribute('data-dn-apply-code'), rowBtn); return; }

    var fieldBtn = closest(e.target, '[data-dn-apply-field], [data-cu-apply-discount], .cu-coupon-apply, #save-discount-btn');
    if (fieldBtn) {
      stop(e);
      var box = closest(fieldBtn, '.cu-coupon') || cartRoot(fieldBtn);
      var input = box ? qs('[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]', box) : null;
      applyDiscountCode(input ? input.value : '', fieldBtn);
      return;
    }
  }
  function handleKeydown(e) {
    if (e.key === 'Escape' && qs('.cu-reward-celebration')) { removeCelebration(); return; }
    if (e.key !== 'Enter' || !inCart(e.target)) return;
    var input = closest(e.target, '[data-dn-coupon-input], [data-cu-discount-input], #discount-code-input, input[name="discount"]');
    if (!input) return;
    stop(e);
    var box = closest(input, '.cu-coupon');
    applyDiscountCode(input.value, box ? qs('[data-dn-apply-field], .cu-coupon-apply', box) : null);
  }
  function observeCart() {
    var host = qs(CART_HOST);
    if (!host || !window.MutationObserver) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      startClock();
      syncInputs(host);
      scheduleSync(140);
    });
    observer.observe(host, { childList: true, subtree: false });
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);
  window.addEventListener('resize', function () {
    var root = qs(CART_HOST);
    var panel = root ? getDetails(root) : null;
    if (panel && panel.classList.contains('is-open')) fitDetailsPanel(root, panel);
  });

  if ($ && $.fn && $.ajax) {
    $(document).ajaxComplete(function (_e, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(url)) scheduleSync(90);
      if (/\/cart(?:\?|$)/.test(url)) { observeCart(); startClock(); syncInputs(); }
    });
  }
  document.addEventListener('cart:updated', function () { scheduleSync(60); });
  document.addEventListener('cart:refresh', function () { scheduleSync(60); });
  window.addEventListener('pageshow', function () { scheduleSync(80); startClock(); });

  function init() {
    observeCart();
    startClock();
    syncInputs();
    scheduleSync(80);
    if (window.console) {
      console.log('[DN Cart v37] asset loaded. Toggles owned by: ' + (window.__DN_CART_TOGGLES__ || 'none'));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* public API — handy from the console while testing */
  window.DNCartUI = {
    version: 37,
    init: init,
    currentSync: function () { return activeSyncPromise; },
    sync: syncRewards,
    verifyRewards: verifyRewards,
    schedule: scheduleSync,
    applyCode: applyDiscountCode,
    openOffers: function () { return openOffers(qs(CART_HOST)); },
    closeOffers: function () { return closeOffers(qs(CART_HOST)); },
    openDetails: function () { return setDetailsState(qs(CART_HOST), true); },
    closeDetails: function () { return setDetailsState(qs(CART_HOST), false); },
    closeCelebration: removeCelebration,
    resetFailedTiers: function () { failedTiers = {}; },
    rewardDebug: function () {
      return getCart().then(function (cart) {
        var cfg = getConfig();
        var activeTier = activeTierFor(cart, cfg);
        var desired = desiredIdsFor(activeTier, cfg);
        return {
          version: 37,
          activeTier: activeTier,
          subtotal: qualifyingSubtotal(cart),
          desiredVariantIds: desired,
          plan: inspectRewardState(cart, desired, activeTier),
          config: cfg,
          cart: cart
        };
      });
    }
  };
  /* backward-compatible alias used by older theme code */
  window.VinovaCartOffers = window.DNCartUI;
  window.applyComboDiscount = function (code) { return applyDiscountCode(code); };
})(window, document);
/* ===================== END DN CUSTOM v37 ===================== */